import { Box } from '@chakra-ui/react';
import { useActiveTab } from 'reducers/viewsSlice';

import { VIEWS_FILTER_KEYS } from 'constants/ProjectConstants';

import { Divider } from 'uiToolkitV1/Divider';

import '../../agGrid.css';
import { FiltersTagList } from '../FiltersTagList';
import { BaseCohort } from './BaseCohort';
import { Employees } from './Employees';
import { Ethnicity } from './Ethnicity';
import { Functions } from './Functions';
import { Genders } from './Genders';
import { Grades } from './Grades';
import { Locations } from './Locations';
import { Managers } from './Managers';
import { Roles } from './Roles';
import { TalentPartnerEmail } from './TalentPartnerEmail';

export const FilterContent = () => {
  const activeTab = useActiveTab();

  let component = <></>;

  switch (activeTab) {
    case VIEWS_FILTER_KEYS.BASE_COHORT:
      component = <BaseCohort />;
      break;
    case VIEWS_FILTER_KEYS.EMPLOYEES:
      component = <Employees />;
      break;
    case VIEWS_FILTER_KEYS.MANAGERS:
      component = <Managers />;
      break;
    case VIEWS_FILTER_KEYS.GRADE:
      component = <Grades />;
      break;
    case VIEWS_FILTER_KEYS.ROLE:
      component = <Roles />;
      break;
    case VIEWS_FILTER_KEYS.FUNCTION:
      component = <Functions />;
      break;
    case VIEWS_FILTER_KEYS.LOCATION:
      component = <Locations />;
      break;
    case VIEWS_FILTER_KEYS.GENDER:
      component = <Genders />;
      break;
    case VIEWS_FILTER_KEYS.ETHNICITY:
      component = <Ethnicity />;
      break;
    case VIEWS_FILTER_KEYS.TALENT_PARTNER_EMAIL:
      component = <TalentPartnerEmail />;
      break;
    default:
      component = <></>;
  }

  return (
    <Box height="100%" px={1}>
      <FiltersTagList />
      <Divider borderColor="#CFD7DF" mr={2} ml={1} my={1} />
      {component}
    </Box>
  );
};
